<template>
  <div class="d-flex justify-content-between align-items-center gap-1 mb-2">
    <div
      class="d-flex gap-2 align-items-center"
    >
      <profile-picture
        :width-and-height-in-pixels="50"
        :background-image-url="imageUrl"
      />
      <h6>
        <router-link
          :to="`/app-users/${userId}`"
        >
          {{ userName }}
        </router-link>
      </h6>
    </div>
    <material-button
      class="px-2"
      color="primary"
      @click.prevent="deleteUser"
    >
      <material-icon
        icon="delete"
      />
    </material-button>
  </div>
</template>

<script>
import MaterialButton from '@/components/MaterialButton.vue';
import MaterialIcon from '@/components/UI/MaterialIcon.vue';
import ProfilePicture from '@/components/UI/ProfilePicture.vue';

import { createYesNoSweetAlert } from '../../helpers/sweetalert';

export default {
  components: {
    MaterialButton,
    MaterialIcon,
    ProfilePicture
  },

  props: {
    userId: { type: Number, required: true },
    imageUrl: { type: String, default: '' },
    userName: { type: String, required: true }
  },

  emits: [
    'deleted'
  ],

  methods: {
    deleteUser() {
      createYesNoSweetAlert(
        `Wilt u ${this.userName} uit de groep verwijderen?`,
        () => this.$emit('deleted', this.userId)
      );
    }
  }
}
</script>